import styled from "styled-components";
import backArrow from "../../../assets/images/icons/arrow-left-straight.svg";
import { colors, fonts } from "../../../styles/variables";

export const Header = styled.div`
  text-align: center;
  position: relative;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const BackArrow = styled.img.attrs(() => ({
  src: backArrow,
}))`
  height: 15px;
  width: 15px;
  position: absolute;
  left: 0;
  cursor: pointer;
  margin: 0 15px;
`;

export const ChallengeDescriptionTitle = styled.h3`
  font-size: 18px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 10px;
`;

export const ChallengeDescriptionWrapper = styled.div`
  background-color: ${colors.peachTint};
  height: 100%;
  padding: 24px 15px;
  font-size: 14px;
  line-height: 20px;
`;

export const ChallengeGameplayTitle = styled.p`
  text-transform: uppercase;
  margin: 0px;
`;
